<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">
         <span>公告管理 / </span>
         <span v-if="edit === false">新增</span>
         <span v-if="edit !== false">编辑</span>
         <el-button class="back" type="primary" @click="$router.go(-1)">返回</el-button>
      </div>

      <div class="form-wrapper">
         <el-form ref="announceForm" :rules="rules" :model="announceForm" label-width="130px">
            <el-form-item label="标题：" prop="title">
               <el-input class="labelWidth" placeholder="请输入标题，不超过50个字符" v-model="announceForm.title">
               </el-input>
            </el-form-item>
            <el-form-item label="内容：" prop="content">
               <el-input class="labelWidth" type="textarea" placeholder="这里填写内容" :autosize="{ minRows: 3 }"
                  v-model="announceForm.content">
               </el-input>
            </el-form-item>
            <el-form-item label="弹框有效期：" prop="validDate">
               <el-date-picker type="datetimerange" v-model="announceForm.validDate"
                  placeholder="请选择弹框有效期"></el-date-picker>
            </el-form-item>
            <el-form-item label="上传图片：" prop="imageUrl">
               <UploadImage actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=8"
                  :urls="announceForm.imageUrl" @onUrls="handleSuccess">
               </UploadImage>
            </el-form-item>
            <select-school :schObj="announceForm.schObj" :isRoot="isRoot"
               @changeVal="handleSchoolChanged"></select-school>
         </el-form>
      </div>

      <div class="margin-20">
         <el-button type="primary" @click="clickSave(1)">保存为草稿</el-button>
         <el-button type="primary" @click="clickSave(2)">保存并发布</el-button>
      </div>
   </div>
</template>

<script>
import UploadImage from "../../../../components/UploadItems/UploadImage.vue";
import selectSchool from "../../../../components/common/selectSch.vue";

export default {
   components: {
      UploadImage,
      selectSchool
   },

   data() {
      let checkDateNull = (rule, value, callback) => {
         if (value && value.length > 0) {
            callback();
         } else {
            callback(new Error("请选择日期"));
         }
      };
      return {
         loading: false,
         edit: false,
         announceForm: {
            title: "",
            content: "",
            validDate: [],
            imageUrl: "",
            schObj: {
               applicableCampus: "0",
               shieldedSchools: [], // 屏蔽的学校
               openedSchools: []    // 应用的学校
            },
         },
         actionUrl: this.$util.domain + '/adminapi/v1/basicTools/upload/one?uploadImageType=8',
         isRoot: false,
         rules: {
            title: [{ min: 1, max: 50, required: true, message: '请输入标题,不超过50个字符', trigger: 'blur' },],
            content: [{ min: 1, max: 10000, required: true, message: '请填写内容', trigger: 'blur' },],
            validDate: [{ required: true, validator: checkDateNull, trigger: 'blur' },],
         }
      }
   },

   mounted() {
      let url = window.location.href;
      if (url.indexOf('?') !== -1) {
         this.edit = true;
         let announceId = this.$util.getUrlParam('id');
         this.getAnnouncementDetail(announceId);
      }
   },

   methods: {
      // 获取公告详情
      getAnnouncementDetail(id) {
         this.$http({
            method: 'GET',
            url: this.$util.domain + '/adminapi/v1/announcement/detail?announcementId=' + id,
         }).then((response) => {
            if (response.data.error === 10000) {
               let data = response.data.data;
               this.announceForm = {
                  title: data.title || '',
                  content: data.content || '',
                  validDate: [new Date(data.bounceStartTime), new Date(data.bounceEndTime)],
                  imageUrl: data.imageUrl,
                  schObj: {
                     shieldedSchools: [],
                     openedSchools: [],
                     applicableCampus: data.applicableCampus ? data.applicableCampus + "" : "0"
                  },
               };
               if (data.annoCampusDTOS && data.annoCampusDTOS.length) {
                  let schArray = data.annoCampusDTOS.map(item => {
                     return { name: item.campusName, rootUnid: item.unid };
                  });
                  if (data.applicableCampus == 0) {
                     this.announceForm.schObj.shieldedSchools = schArray;
                  } else {
                     this.announceForm.schObj.openedSchools = schArray;
                  }
               }
            }
         })
      },

      // 发送公告详情
      sendAnnouncement(status) {
         let startTime = this.announceForm.validDate[0];
         let endTime = this.announceForm.validDate[1];
         let rootUnids = [], schObj = this.announceForm.schObj;
         if (schObj.applicableCampus == 0 && schObj.shieldedSchools.length) {
            for (let i = 0; i < schObj.shieldedSchools.length; i++) {
               rootUnids.push({
                  campusName: schObj.shieldedSchools[i].name,
                  unid: schObj.shieldedSchools[i].rootUnid * 1
               })
            }
         } else if (schObj.applicableCampus == 1 && schObj.openedSchools.length) {
            for (let i = 0; i < schObj.openedSchools.length; i++) {
               rootUnids.push({
                  campusName: schObj.openedSchools[i].name,
                  unid: schObj.openedSchools[i].rootUnid * 1
               })
            }
         }
         let requestBody = {
            title: this.announceForm.title.trim(),
            content: this.announceForm.content,
            bounceStartTime: startTime.getTime(),
            bounceEndTime: endTime.getTime(),
            imageUrl: this.announceForm.imageUrl,
            applicableCampus: schObj.applicableCampus * 1,//0,全部校区；1，部分校区；
            campusDTOS: rootUnids,
            publisher: this.$store.state.user.name,
            publisherId: this.$store.state.user.userId,
            updateStatus: status,
         };
         if (this.edit) {
            requestBody.id = this.$util.getUrlParam('id');
         }
         this.$http({
            url: this.$util.domain + '/adminapi/v1/announcement/edit',
            method: 'POST',
            body: JSON.stringify(requestBody)
         }).then(response => {
            if (response.data.error === 10000) {
               this.$util.successMsg(this.edit ? "编辑成功" : "添加成功");
               history.go(-1);
            } else {
               this.$util.errorMsg(response.data.message);
            }
         })
      },

      // 点击保存
      clickSave(status) {
         this.$refs.announceForm.validate((valid) => {
            if (valid) {
               this.sendAnnouncement(status);
            }
         });
      },

      // 上传文件成功
      handleSuccess(img) {
         this.announceForm.imageUrl = img;
      },

      // 选择学校
      handleSchoolChanged(res) {
         this.announceForm.schObj = res;
      },
   }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// AnnouncementDetail.vue?55558093